import { makeStyles } from '@material-ui/core';

import { pdvColor, pdvRadius } from '../tokens';

export const useStyles = makeStyles({
  track: {
    position: 'relative',
    display: 'block',
    height: 8,
    marginTop: 4,
    borderRadius: pdvRadius.pill,
    background: pdvColor.surfaceSubtle,
    overflow: 'hidden'
  },
  fill: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    borderRadius: pdvRadius.pill
  }
});
